import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const professionEduAreaService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/edu-area/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching profession list", error);
            throw error;
        }
    },

    async findByUuid(uuid: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/edu-area/findByUuid/${uuid}`);
            return response.data;
        } catch (error) {
            console.error("Error findByUuid profession", error);
            throw error;
        }
    },

    async save(profession: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/edu-area/save`,
                profession
            );
            return response.data;
        } catch (error) {
            console.error("Error save profession", error);
            throw error;
        }
    },


    async deleteByUuid(uuid: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/edu-area/deleteByUuid/${uuid}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteByUuid profession", error);
            throw error;
        }
    },
    async getAllList(): Promise<any[]> {
        try {
            const response = await apiClient.get<any[]>(`${BASE_URL}/api/v1/edu-area/all-list`);
            return response.data;
        } catch (error) {
            console.error("Error getAllList", error);
            throw error;
        }
    },
}

export default professionEduAreaService;
